import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import MediaHero from "../../components/MediaHero/MediaHero";
import TypesOfContentSection from "../../components/TypesOfContentSection/TypesOfContentSection";
import ListenNowSection from "../../components/ListenNowSection/ListenNowSection";
import styles from "./Media.module.css";

const Media = () => {
  const location = useLocation();
  const listenRef = useRef(null);

  /* Scroll to the ListenNowSection only when we arrived
     with state={ scrollTo: 'listen' } */
  useEffect(() => {
    if (location.state?.scrollTo === "listen" && listenRef.current) {
      // give ScrollToTop one frame, then smooth-scroll
      requestAnimationFrame(() => {
        listenRef.current.scrollIntoView({ behavior: "smooth" });
      });
    }
  }, [location]);

  return (
    <div className={styles.mediaPage}>
      <MediaHero />
      <TypesOfContentSection />
      <ListenNowSection ref={listenRef} />
    </div>
  );
};

export default Media;
